import {
  useCities,
  useCountries,
  useRegions,
  useSubcities,
  useWoredas,
  useZones
} from "features/members";
import { useEffect } from "react";

export const useStructureDetailAddressQueries = (
  watch,
  setValue,
  structureQuery
) => {
  // Get watched values
  const countryId = watch("country_id");
  const regionId = watch("region_id");
  const zoneId = watch("zone_id");
  const cityId = watch("city_id");
  const subcityId = watch("sub_city_id");

  // Address queries
  const countriesQuery = useCountries();

  const regionsQuery = useRegions({
    countryId,
    config: {
      enabled: !!countryId
    }
  });

  const zonesQuery = useZones({
    regionId,
    config: {
      enabled: !!regionId
    }
  });

  const citiesQuery = useCities({
    zoneId,
    config: {
      enabled: !!zoneId
    }
  });

  const subcitiesQuery = useSubcities({
    cityId,
    config: {
      enabled: !!cityId
    }
  });

  const woredasQuery = useWoredas({
    subcityId,
    config: {
      enabled: !!subcityId
    }
  });

  // Effects for form initialization
  useEffect(() => {
    if (countriesQuery.data && structureQuery.data?.result) {
      setValue(
        "country_id",
        String(structureQuery.data.result.country_id || "")
      );
    }
  }, [countriesQuery.data, structureQuery.data, setValue]);

  useEffect(() => {
    if (regionsQuery.data && structureQuery.data?.result) {
      setValue("region_id", String(structureQuery.data.result.region_id || ""));
    }
  }, [regionsQuery.data, structureQuery.data, setValue]);

  useEffect(() => {
    if (zonesQuery.data && structureQuery.data?.result) {
      setValue("zone_id", String(structureQuery.data.result.zone_id || ""));
    }
  }, [zonesQuery.data, structureQuery.data, setValue]);

  useEffect(() => {
    if (citiesQuery.data && structureQuery.data?.result) {
      setValue("city_id", String(structureQuery.data.result.city_id || ""));
    }
  }, [citiesQuery.data, structureQuery.data, setValue]);

  useEffect(() => {
    if (subcitiesQuery.data && structureQuery.data?.result) {
      setValue(
        "sub_city_id",
        String(structureQuery.data.result.sub_city_id || "")
      );
    }
  }, [subcitiesQuery.data, structureQuery.data, setValue]);

  useEffect(() => {
    if (woredasQuery.data && structureQuery.data?.result) {
      setValue("woreda_id", String(structureQuery.data.result.woreda_id || ""));
    }
  }, [woredasQuery.data, structureQuery.data, setValue]);

  return {
    countriesQuery,
    regionsQuery,
    zonesQuery,
    citiesQuery,
    subcitiesQuery,
    woredasQuery
  };
};
